










import { BrowserKinds, BrowserUtility } from "../../utilities";
import { Component, Mixins, Prop } from "vue-property-decorator";

@Component
export default class BackgroundView extends Mixins() {
  @Prop()
  message: string;

  @Prop()
  isProcessing: boolean;

  @Prop({ default: 400 })
  width: number;

  @Prop({ default: 125 })
  height: number;

  async created(): Promise<void> {
    // バックグラウンド実行時はIE以外の場合自分でサイズを変更する.
    // (IEはKickerがCOM制御で見えないサイズに調整するので邪魔しない.)
    if (BrowserUtility.getBrowserKind() !== BrowserKinds.InternetExplorer) {
      window.moveTo(0, 0);
      window.resizeTo(this.width, this.height);
    }
  }
}
